// EXPERIMENT: psf_promote_or_share_qr_code_experiment — remove with experiment cleanup
import type React from 'react';
import { useEffect, useRef } from 'react';

/**
 * EXPERIMENT: psf_promote_or_share_qr_code_experiment.
 * The body of a slide-up step that replaces the previous one. The button that opened the step unmounts
 * with the previous step, so focus moves to this body on mount rather than falling back to the page. A
 * step whose header has no title passes `labelledBy`, so the section's name tells screen readers the
 * view changed.
 */
export const StepBody: React.FC<StepBodyProps> = ({ children, testId, labelledBy }) => {
	const rootRef = useRef<HTMLElement>(null);

	useEffect(() => {
		rootRef.current?.focus({ preventScroll: true });
	}, []);

	return (
		<section
			ref={rootRef}
			tabIndex={-1}
			aria-labelledby={labelledBy}
			className="flex w-full flex-col items-center gap-4 outline-none"
			data-testid={testId}
		>
			{children}
		</section>
	);
};

type StepBodyProps = {
	children: React.ReactNode;
	testId: string;
	/** The id of the element that names the step. */
	labelledBy?: string;
};
